import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage.tsx';
import {rbacActions} from '../../config/rbac/actions.ts';

// READ-ONLY (FNP-969): two routes only. There is no `add` route and no edit
// route because there is nothing to add or edit — openTestRun / closeTestRun /
// abandonTestRun are @aws_iam, written by the executor canary.
export const TestRunsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListTestRuns}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path=':id'
                element={
                    <RequirePermission action={rbacActions.GetTestRun}>
                        <DetailPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
